import "./index.css";

const SuccessMetrics = () => {
  return (
    <section className="metrics-card">
      <h3>Placement Success Metrics</h3>
      <div className="metrics-grid">
        <div className="metric">
          <div className="metric-value blue">350+</div>
          <div className="metric-title">Hiring Partners</div>
          <div className="metric-subtitle">Active recruiters</div>
        </div>

        <div className="metric">
          <div className="metric-value green">₹3–18L</div>
          <div className="metric-title">Salary Range</div>
          <div className="metric-subtitle">Based on skills</div>
        </div>

        <div className="metric">
          <div className="metric-value purple">3.5x</div>
          <div className="metric-title">Average Salary Hike</div>
          <div className="metric-subtitle">Career switchers</div>
        </div>

        <div className="metric">
          <div className="metric-value teal">45 Days</div>
          <div className="metric-title">Internship Search</div>
          <div className="metric-subtitle">Post completion</div>
        </div>
      </div>
    </section>
  );
};

export default SuccessMetrics;
